<section
  class="toggle-form"
  [ngClass]="{ active: isDocumentProficiencyQuizSliderOpen }"
>
  <div class="formwrap">
    <div class="header">
      <h2>
        <b>{{ topBarTitle }}</b>
      </h2>
      <p-button
        appPreventDoubleClick
        styleClass="p-button-text"
        id="docuumentProficiencyQuizSliderCloseButton"
        type="button"
        label="Close"
        (debounceClick)="confirm()"
      ></p-button>
    </div>
    <div class="quiz-content-holder">
      <div
        *ngIf="errorMessages.length > 0"
        class="docProficiencyQuizSliderErrorMessagePlaceHolder"
      >
        <p-messages severity="error">
          <ng-template pTemplate>
            <div class="p-message-wrapper">
              <div>
                <span class="p-message-icon pi pi-times-circle"></span>
                <span class="p-ml-2">{{ errorMessageHeaderText }}</span>
              </div>
              <div>
                <ul>
                  <li *ngFor="let errorText of errorMessages">
                    {{ errorText }}
                  </li>
                </ul>
              </div>
            </div>
          </ng-template>
        </p-messages>
      </div>
      <div class="proficiency-quiz-container">
        <div class="fields-row">
          <div class="field">
            <p-checkbox
              p-label-active
              label="Requires Proficiency Quiz"
              [binary]="true"
              id="requiresProficiencyQuiz"
              [(ngModel)]="requiresProficiencyQuiz"
              (ngModelChange)="enableOrDisableQuizSection()"
              [disabled]="!documentDetailsDto.isProficiencyQuizSaveButton"
            >
            </p-checkbox>
          </div>
          <div class="field field-required">
            <bpt-numeric-input
              label="Minimum Passing Score"
              [(ngModel)]="minimumPassingScore"
              [required]="requiresProficiencyQuiz"
              [disabled]="!requiresProficiencyQuiz || !documentDetailsDto.isProficiencyQuizSaveButton"
              [ngClass]="{ 'error-highlight': !isMinimumPassingScoreValid }"
              [allowNegative]="false"
              id="minimumPassingScore"
              [showButtons]="true"
              [minValue]="0"
              (numericInputKeyUp)="onMinimumPassingScoreChange($event)"
              [maxValue]="100"
              [step]="1"
            >
            </bpt-numeric-input>
          </div>
          <div class="field">
            <bpt-numeric-input
              label="Max # of Attempts"
              [(ngModel)]="maxOfAttempts"
              [allowNegative]="false"
              [disabled]="!requiresProficiencyQuiz || !documentDetailsDto.isProficiencyQuizSaveButton"
              id="maxOfAttempts"
              (numericInputKeyUp)="onMaxOfAttemptsChange($event)"
              [showButtons]="true"
              [minValue]="1"
              [step]="1"
            >
            </bpt-numeric-input>
          </div>
        </div>
        <div class="quiz-container" *ngIf="loadQuizCreator">
          <app-quiz-creator [quizText]="quiz" [isShowPreviewOnly] = "!documentDetailsDto.isProficiencyQuizSaveButton"></app-quiz-creator>
        </div>
        <div>
          <p-button
            appPreventDoubleClick
            label="Save"
            type="submit"
            id="documentProficiencyQuizSaveButton"
            [disabled]="!documentDetailsDto.isProficiencyQuizSaveButton"
            class="align-right"
            styleClass="bpt-button-compact"
            (debounceClick)="saveProficiencyQuiz()"
          >
          </p-button>
        </div>
      </div>
    </div>
  </div>
</section>
